import React, { useState, useEffect } from "react";
import {Input, Form, Col, Row, Button, Select, Tooltip} from "antd";
import {PlusOutlined, QuestionCircleOutlined} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import {
  defaultValidateMessages,
  onInputMaxLengthCheck,
  onKeyDownNumberOnly,
} from "./Helper";
import TextArea from "antd/lib/input/TextArea";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const TosBankInfoUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [activeBankId, setActiveBankId] = useState();
  const [bankRequirement, setBankRequirement] = useState({});

  const [connectionType, setConnectionType] = useState("none");

  const [isSupportwebService, setIsSupportwebService] = useState(false);
  const [isSupportSftp, setIsSupportSftp] = useState(false);
  const [isSupportMail, setIsSupportMail] = useState(false);
  const [isSupportPdf, setIsSupportPdf] = useState(false);

  useEffect(() => {
    if (props.data) {

      if(props.data.isUseEmail) {
        props.data.connectionType = "mail"
        setConnectionType("mail");
      }
      else if(props.data.isUseWebService) {
        props.data.connectionType = "webService";
        setConnectionType("webService");

      }
      else if (props.data.isUsePdf) {
        props.data.connectionType = "pdf";
        setConnectionType("pdf");
      } else {
        props.data.connectionType = "sftp"
        setConnectionType("sftp");
      }

      form.setFieldsValue(props.data);
      setActiveBankId(props.data.bankId);

      if(props.data.bankId) {
        RequestHandler.get(`/Bank/GetById/${props.data.bankId}`).then((response) => {
          setIsSupportSftp(response.isTosSupport);
          setIsSupportwebService(response.isOnlineTosSupport);
          setIsSupportMail(response.isMailTosSupport);
          setIsSupportPdf(response.isTosSupportPdf);
        });
      }
    }
  }, [props.data]);

  const onFinish = (values) => {
    setLoading(true);
    if(values.connectionType == "mail") {
      values.IsUseEmail = true;
    }

    if(values.connectionType == "webService") {
      values.IsUseWebService = true;
    }

    if(values.connectionType == "pdf") {
      values.IsUsePdf = true;
    }

    delete values.connectionType;


    RequestHandler.put(`/TosBankInfo`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        form.resetFields();
        setConnectionType("none");

        if (props.onSuccess) props.onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const onConnectionTypeChange = (type) => {
    setConnectionType(type);
  }

  const FormItemLabelWithTooltip = ({ label, tooltip }) => {
    return (
      <>
        {label}{" "}
        <Tooltip title={
          <span>
            {tooltip?.split('*').filter(part => part.trim() !== '').map((line, index) => (
              <div key={index}> * {line}</div>
            ))}
          </span>
        } overlayStyle={{ maxWidth: "450px" }}>
          <QuestionCircleOutlined
            className="gx-text-blue"
            style={{ marginLeft: 5,marginRight:3, fontSize: "120%" }}
          />
        </Tooltip>
      </>
    );
  };

  return (
    <Form
      {...formItemLayout}
      validateMessages={defaultValidateMessages}
      form={form}
      name="tosBankInfoUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="bankId" hidden>
            <Input />
          </Form.Item>

          <Form.Item name="connectionType" label="Bağlantı Tipi">
              <Select placeholder="Seçiniz" onChange={onConnectionTypeChange}>
                { isSupportSftp ? <Select.Option key="sftp" value="sftp">Sftp</Select.Option> : <></>  }
                { isSupportMail ? <Select.Option key="mail" value="mail">Mail</Select.Option> : <></> }
                { isSupportwebService ? <Select.Option key="webService" value="webService">Web Servis</Select.Option> : <></> }
                { isSupportPdf ? <Select.Option key="pdf" value="pdf">Pdf</Select.Option> : <></> }
              </Select>
          </Form.Item>

          { connectionType == "sftp" ?
            <>

              <Form.Item
                label={
                  "Müşteri Numarası"
                }
                name="customerNumber"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input maxLength="125" onInput={onInputMaxLengthCheck} />
              </Form.Item>
                  {
                    props.data.bankId === 15 ?
                  <Form.Item
                    label={
                        "Kurum Kodu"
                    }
                    name="corporateCode"
                    rules={[{ required: true, whitespace: true }]}
                  >
                    <Input maxLength="5" onInput={onInputMaxLengthCheck} />
                  </Form.Item>
                    :
                    null
                  }
                <Form.Item style={{ marginBottom: 0 }} label="Host" required>
                  <Input.Group>
                    <Row gutter={2}>
                      <Col span={18}>
                          <Form.Item
                            name="host"
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "'Host' alanı gerekli.",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                      </Col>
                      <Col span={6}>
                          <Form.Item
                            name="port"
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "'Port' alanı gerekli.",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Port"
                              onKeyDown={(e) => onKeyDownNumberOnly(e)}
                              maxLength="5"
                              onInput={onInputMaxLengthCheck}
                            />
                          </Form.Item>
                      </Col>
                    </Row>
                  </Input.Group>
                </Form.Item>
              <Form.Item
                label={
                  <FormItemLabelWithTooltip
                    label="Gelen Dosya Yolu"
                    tooltip="info@koletra.com mail adresine sorarak öğreniniz."
                  />
                }
                name="downloadFolder"
                rules={[{ required: true, whitespace: true }]}
              >
                <Input />
              </Form.Item>
                <Form.Item
                  label={
                    <FormItemLabelWithTooltip
                      label="Giden Dosya Yolu"
                      tooltip="info@koletra.com mail adresine sorarak öğreniniz."
                    />
                  }
                  name="uploadFolder"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input />
                </Form.Item>


                <Form.Item
                  label={
                       "Kullanıcı Adı"
                  }
                  name="userName"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Şifre"
                  name="password"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
            </>
             :
             connectionType == "mail" ?
              <>
                <Form.Item
                  label={
                    "Müşteri Numarası"
                  }
                  name="customerNumber"
                  rules={[{ required: true, whitespace: true }]}
                >
                  <Input maxLength="125" onInput={onInputMaxLengthCheck} />
                </Form.Item>
                 <Form.Item
                    label="Alıcı E-postaları"
                    name="emailAddresses"
                    rules={[
                      {
                        validator: (rule, values) => {
                          if (!values) {
                            return Promise.resolve();
                          }

                          const emailRegex =
                            /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
                          const invalidInputs = values.filter(
                            (value) => !value.match(emailRegex)
                          );
                          if (invalidInputs.length === 0) {
                            return Promise.resolve();
                          }

                          if (invalidInputs.length === 1) {
                            return Promise.reject(
                              new Error(
                                `'${invalidInputs.join(
                                  ""
                                )}' geçersiz bir e-postadır.`
                              )
                            );
                          } else {
                            return Promise.reject(
                              new Error(
                                `'${invalidInputs.join(
                                  ", "
                                )}' değerleri geçersiz e-postadır.`
                              )
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      showSearch
                      tokenSeparators={[",", ";"]}
                      mode="tags"
                      placeholder={
                        "Talimat girilen mail adreslerine gönderilir."
                      }
                    ></Select>
                  </Form.Item>
              </>
              : connectionType === "webService" ?
                 <>
                   <Form.Item
                     label={
                       "Kullanıcı Adı"
                     }
                     name="userName"
                     rules={[{ required: true, whitespace: true, message: "'Kullanıcı Adı' alanı gerekli." }]}
                   >
                     <Input />
                   </Form.Item>

                   <Form.Item
                     label="Şifre"
                     name="password"
                     rules={[{ required: true, whitespace: true, message: "'Şifre' alanı gerekli." }]}
                   >
                     <Input.Password autoComplete="new-password" />
                   </Form.Item>

                   {
                     activeBankId === 15 ?  <>
                       <Form.Item
                         label={
                           "Müşteri Numarası"
                         }
                         name="customerNumber"
                         rules={[{ required: true, whitespace: true }]}
                       >
                         <Input maxLength="125" onInput={onInputMaxLengthCheck} />
                       </Form.Item>


                       <Form.Item
                         label={
                           "Kurumsal Kod"
                         }
                         name="corporateCode"
                         rules={[{ required: true, whitespace: true, message: "'Kurumsal Kod' alanı gerekli." }]}
                       >
                         <Input />
                       </Form.Item></> :   activeBankId === 210 ? <> </>  : <>

                       <Form.Item
                         label={
                           "Client Id"
                         }
                         name="clientId"
                         rules={[{ required: true, whitespace: true, message: "'Client Id' alanı gerekli." }]}
                       >
                         <Input />
                       </Form.Item>

                       <Form.Item
                         label={
                           "Client Secret"
                         }
                         name="clientSecret"
                         rules={[{ required: true, whitespace: true, message: "'Client Secret' alanı gerekli." }]}
                       >
                         <Input />
                       </Form.Item>

                       {
                         activeBankId === 64 ? <>

                           <Form.Item
                             label={
                               "Sertifika"
                             }
                             name="clientCertificate"
                             rules={[{ required: true, whitespace: true, message: "'Sertifika' alanı gerekli." }]}
                           >
                             <TextArea rows={10} />
                           </Form.Item>

                         </> : <></>
                       }

                     </>

                   }

                 </> : <></>

          }
          <Col style={{ textAlign: "right" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              htmlType="submit"
              loading={loading}
            >
              Güncelle
            </Button>
          </Col>
        </Col>
      </Row>
    </Form>
  );
};
export default TosBankInfoUpdateForm;
